import { Component, OnInit } from '@angular/core';
import { AppData } from '../../../constants/app-data';
import { CommonService } from '../../../services/common.service';

@Component({
  selector: 'app-menu-left',
  templateUrl: './left.component.html',
  styleUrls: ['./left.component.css']
})
export class LeftComponent implements OnInit {
  showFiller: boolean; 
	
  constructor(public appData: AppData, public commonService: CommonService) { 
  	//console.log('LeftComponent constructor');
  }

  ngOnInit(): void {
  	//console.log('LeftComponent ngOnInit');
  }
	
   
}
